import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const SearchIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 17 17">
    <path
      d="M15.8334 15.8335L12.9168 12.9168M15 7.91683C15 11.8288 11.8287 15.0002 7.91671 15.0002C4.00469 15.0002 0.833374 11.8288 0.833374 7.91683C0.833374 4.00481 4.00469 0.833496 7.91671 0.833496C11.8287 0.833496 15 4.00481 15 7.91683Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
